import { useRef, useContext } from "react"
import Header from "../../../../layouts/Header"
import BackIcon from "../../../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import { Box, Tooltip, IconButton } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CustomBackdrop from "../../../../components/CustomBackdrop"
import { useMutation, api } from "../../../../api"
import { GlobalContext } from "../../../../contexts/GlobalContext"
import getIconComponent from "../../../utils/getIconComponent"
import FormularioCandidato from "../componentes/FormularioCandidato"

// Tema estándar de SIAC
const theme = createTheme({
  palette: {
    primary: { main: "#196C87" },
    secondary: { main: "#2E7D32" },
  },
})

const CrearCandidato = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)
  const formRef = useRef()

  // ========================================================
  // LECTURA ROBUSTA DE PERMISOS (FALLBACK A LOCALSTORAGE)
  // ========================================================
  let barraAcciones = selectedMenuInfo?.data?.barraAcciones

  if (!barraAcciones || barraAcciones.length === 0) {
    try {
      const menuAccionesRaw = localStorage.getItem("menuAcciones")
      if (menuAccionesRaw) {
        const menuAcciones = JSON.parse(menuAccionesRaw)
        // Los permisos del formulario hijo se heredan de la ruta del módulo principal
        const currentMenu = menuAcciones["ControlElectoral/Candidatos"]
        if (currentMenu && currentMenu.barraAcciones) {
          barraAcciones = currentMenu.barraAcciones
        }
      }
    } catch (error) {
      console.error("Error leyendo permisos desde localStorage:", error)
    }
  }

  // ========================================================
  // MUTACIÓN PARA GUARDAR EL NUEVO CANDIDATO
  // ========================================================
  const { mutateAsync: SaveCreacion, isPending: isSaving } = useMutation({
    queryKey: ["isCreatingCandidato"],
    fn: async (data) => {
      // Apunta al endpoint exacto que creamos en rutas_maestros.py
      const response = await api.post("/ControlElectoral/crearCandidato", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1), // Retorna a la tabla principal al guardar exitosamente
  })

  // Capturamos el botón "GRABAR" usando el arreglo validado
  const ejecutarAction = barraAcciones?.find((action) => action?.acccaption === "GRABAR")

  const handleSubmit = async (formData) => {
    await SaveCreacion(formData)
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        {/* BARRA DE ACCIONES SUPERIOR (BOTÓN GRABAR) */}
        <Box sx={{ mb: 2 }}>
          {ejecutarAction && (
            <Tooltip title={ejecutarAction.acccaption}>
              <IconButton
                onClick={() => formRef.current?.handleSubmit()}
                disabled={isSaving}
                sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1 }}
              >
                {getIconComponent(ejecutarAction.accnameicono, ejecutarAction.acctipoico)}
              </IconButton>
            </Tooltip>
          )}
        </Box>

        {/* TÍTULO DE LA PANTALLA */}
        <div style={{ textAlign: "center", fontSize: "25px", marginBottom: "20px" }}>
          <b>Crear Nuevo Candidato</b>
        </div>

        <CustomBackdrop isLoading={isSaving} />

        {/* COMPONENTE HIJO CON EL FORMULARIO */}
        <FormularioCandidato ref={formRef} isLoading={isSaving} onSubmit={handleSubmit} modo="crear" />
      </div>
    </ThemeProvider>
  )
}

export default CrearCandidato
